import Vue from 'vue'
import api from '../../api/api'

const question = {
  state: {
    typeList: [],
    list: [],
    page: {}
  },

  mutations: {
    SET_QUESTION_TYPE_LIST(state, data) {
      state.typeList = data || []
    },

    SET_QUESTION_LIST(state, data) {
      state.list = data.list || []
      state.page = {
        page:data.pageno,
        total:data.totalcount
      }
    }
  },

  actions: {
    //获取题目类型列表
    async getQuestionTypeList({ commit }) {
      let ret = await api.getQuestionType()
      commit('SET_QUESTION_TYPE_LIST', ret.data)
      console.log('题目类型列表', ret)
    },

    async getQuestionList({ commit, rootState }) {
      let params = Object.assign({},rootState.route.query)
      let ret = await api.getQuestion(params)
      commit('SET_QUESTION_LIST', ret.data)
      console.log('题目列表', ret)
    }
  }

};

export default question


// WEBPACK FOOTER //
// ./src/store/modules/question.js